export enum NetworkConnectionStatusEnum {
	OPEN = 'OPEN',
	CLOSED = 'CLOSED',
	CONNECTING = 'CONNECTING',
}
